module.exports = __webpack_public_path__ + "static/media/ZiXun3.397d66a5.png";